import { AccountData } from "@markit/common.types";
import FeaturedPeopleCard from "./FeaturedPeopleCard";
import { HorizontalDivider } from "../Dividers/HorizontalDivider";
import { ReactNode, useMemo } from "react";
import { checkIsDesktop } from "../../utils/screenResponsivenessUtils";
import { useWindowResize } from "../../hooks/useWindowResize";

type FeaturedPeopleProps = {
  featuredPeople: AccountData[];
  title: string;
  icon: ReactNode;
  subtext: string;
};

const FeaturedPeople = (props: FeaturedPeopleProps) => {
  const { featuredPeople, title, subtext, icon } = props;

  const windowWidth = useWindowResize();

  const isDesktopSize = useMemo(
    () => checkIsDesktop(windowWidth),
    [windowWidth]
  );

  const styles = {
    title: {
      fontSize: isDesktopSize ? 32 : 24,
      fontWeight: 600,
    },

    content: {
      display: "grid",
      gridTemplateColumns: isDesktopSize ? "repeat(3, 1fr)" : "1fr",
      gap: 14,
    },
  };

  return (
    <div>
      <div
        className="ColumnNormal"
        style={{ gap: isDesktopSize ? 7 : 4, marginBottom: 24 }}
      >
        <div className="AlignedRow" style={{ gap: 14 }}>
          <span style={styles.title}>{title}</span>
          {icon}
        </div>
        <span className="bodySubtext">{subtext}</span>
      </div>
      <HorizontalDivider altMargin={isDesktopSize ? 30 : 24} />
      <div style={styles.content}>
        {(isDesktopSize ? featuredPeople : featuredPeople.slice(0, 6)).map(
          (person) => (
            <FeaturedPeopleCard person={person} key={person.uid} />
          )
        )}
      </div>
    </div>
  );
};

export default FeaturedPeople;
